<template>
    <div class="d-flex flex-column">
        <b-container class="flex-grow-1 d-flex flex-column" fluid>
            <!-- User Interface controls -->
            <b-row class="flex-grow-1 flex-column">
                <b-col md="12" class="d-flex products flex-grow-1 flex-column">

                    <!--</b-card>-->
                    <!--<div class="container">-->
                    <div v-if="tasks.length !== 0" class="d-flex flex-grow-1">
                        <b-card no-body v-if="tasks.length !== 0" class="flex-grow-1 grid grid-3 headGrid" header-class="py-2">
                            <task-product-item v-for="productTask in paginatedData"
                               :key="productTask.id"
                               :productTask="productTask"
                               @task-clicked="selectTask(productTask)"
                               :userRole="userRole"
                               :active="isActiveTask(productTask)"
                               :spinning="isSpinning(productTask)"
                               :selected="isSelectedTask(productTask)"></task-product-item>
                        </b-card>
                    </div>
                    <b-card no-body v-if="tasks.length === 0" class="stubCenter">
                        <h5>Очередь заказов пуста</h5>
                    </b-card>
                    <b-row no-gutters class="footPad flex-shrink-0">
                        <b-col md="4">
                            <b-btn class="w-100 h-100"
                                   :disabled="pageNumber === 0" variant="dark"
                                   @click="prevPage">Предыдущая страница
                            </b-btn>
                        </b-col>
                        <b-col md="4">
                            <b-card class="pageInfo">
                                <p>Страница {{pageNumber+1}} из ({{pageCount}})</p>
                            </b-card>
                        </b-col>
                        <b-col md="4">
                            <b-btn class="w-100 h-100" variant="dark"
                                   :disabled="pageNumber >= pageCount -1"
                                   @click="nextPage">Следующая страница
                            </b-btn>
                        </b-col>
                    </b-row>

                    <b-row class="flex-shrink-0">
                        <b-card no-body class="col-md-6 nullPad" header-class="py-2">
                            <div slot="header" class="">
                                <b>Кол-во продуктов в очереди: {{tasks.length}}</b>
                            </div>
                        </b-card>
                        <b-btn class="col-md-3" variant="danger"
                               :disabled="!isSelectedTasks"
                               @click="Cancel">Отмена выделения
                        </b-btn>
                        <b-btn class="col-md-3" variant="success"
                               :disabled="!isSelectedTasks"
                               @click="readyTask()">Приготовлено
                        </b-btn>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import {
  TASKS_PIZZA_ROLLER,
  TASKS_PIZZA_COOKER
} from '@/constants/graphql'
import {USER_ROLE_PIZZA_COOKER, USER_ROLE_PIZZA_DOUGH} from '../constants/roles'
import {STATUS_TASK_WORKSHOP, TYPE_DELIVERY, UPDATE_STAGE_TASK} from '../constants/keywords'
import {WORKSHOP_CHANGE_STAGE} from '../constants/graphql'
import TaskProductItem from './TaskProductItem'
export default {
  name: 'ListProducts',
  created () {

  },
  data () {
    return {
      TYPE_DELIVERY,
      pageNumber: 0,
      currentTasks: [],
      selectedTasks: [],
      spinningTasksIds: [],
      currentTaskId: null,
      currentTask: null,
      tasksProducts: [],
      userRole: null,
      initedState: false,
      maxCurrentTasks: {
        [USER_ROLE_PIZZA_DOUGH]: 2,
        [USER_ROLE_PIZZA_COOKER]: 3
      },
      roles: {USER_ROLE_PIZZA_COOKER, USER_ROLE_PIZZA_DOUGH},
      stageQueue: null,
      stageWorking: null,
      stageFinished: null,
      stageDeletedProduct: null,
      intervalUpdate: null,
      intervalInit: null,
      productDescription: ['Сп', 'В10', 'СЫР', 'Т', 'Б']
    }
  },
  apollo: {
    tasksProducts: {
      query () {
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_DOUGH) {
          return TASKS_PIZZA_ROLLER
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_COOKER) {
          return TASKS_PIZZA_COOKER
        }
      },
      pollInterval: 10000,
      update (data) {
        // console.log(data)
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_DOUGH) {
          if (data.tasksPizzaRoller) {
            if (data.tasksPizzaRoller.nodes.length !== this.tasksProducts.length) {
              let audio = new Audio(require('../sounds/sound_pizza.wav')) // path to file
              audio.play()
            }
            return data.tasksPizzaRoller.nodes
          } else {
            return []
          }
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_COOKER) {
          if (data.tasksPizzaCooker) {
            if (data.tasksPizzaCooker.nodes.length !== this.tasksProducts.length) {
              let audio = new Audio(require('../sounds/sound_pizza.wav')) // path to file
              audio.play()
            }
            return data.tasksPizzaCooker.nodes
          } else {
            return []
          }
        }
      }
    }
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: 9
    }
  },
  created () {
    this.userRole = this.$userControl.jwtParsed.role
    this.stageDeletedProduct = STATUS_TASK_WORKSHOP.PIZZA.DELETED
    if (this.userRole === USER_ROLE_PIZZA_DOUGH) {
      this.stageQueue = STATUS_TASK_WORKSHOP.PIZZA.WAITING
      this.stageWorking = STATUS_TASK_WORKSHOP.PIZZA.ROLLING
      this.stageFinished = STATUS_TASK_WORKSHOP.PIZZA.ROLLED
    }
    if (this.userRole === USER_ROLE_PIZZA_COOKER) {
      this.stageQueue = STATUS_TASK_WORKSHOP.PIZZA.ROLLED
      this.stageWorking = STATUS_TASK_WORKSHOP.PIZZA.FILLING
      this.stageFinished = STATUS_TASK_WORKSHOP.PIZZA.BAKING
    }
    // setTimeout(() => {
    //   document.location.reload(true)
    // }, 30 * 60 * 1000)
  },
  mounted () {
    this.refreshCurrent()
    setTimeout(() => { this.timeUpdate() }, 500)
    this.intervalInit = setInterval(() => { this.refreshCurrent() }, 1000)
    this.intervalUpdate = setInterval(() => { this.timeUpdate() }, 30000)
  },
  watch: {
    tasksProducts () {
      this.timeUpdate()
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalUpdate)
  },
  methods: {
    refreshCurrent () {
      if (!this.initedState) {
        if (this.tasks.length !== 0) {
          let i
          for (i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].stageWorkshop === this.stageWorking) {
              if (this.currentTasks.length < this.maxCurrentTasks[this.userRole]) {
                this.currentTasks.push(this.tasks[i])
              }
            }
          }
          this.initedState = true
        }
      } else {
        clearInterval(this.intervalInit)
      }
    },
    timeUpdate () {
      this.tasksProducts.forEach(task => {
        let time = this.waitingTime(task.timeCreation)
        this.$set(task, 'time', time)
      })
      // setTimeout(() => { this.timeUpdate() }, 5000)
    },
    isActiveTask (task) {
      return this.currentTasks.some((item) => item.id === task.id)
    },
    isSelectedTask (task) {
      return this.selectedTasks.some((item) => item.id === task.id)
    },
    selectTask (task) {
      let isCurrentTask = this.currentTasks.find(item => item.id === task.id)
      if (isCurrentTask) {
        if (!this.selectedTasks.find(item => item.id === task.id)) {
          this.selectedTasks.push(task)
        } else {
          this.selectedTasks.splice(this.selectedTasks.indexOf(task), 1)
        }
      } else {
        if (this.currentTasks.length < this.maxCurrentTasks[this.userRole]) {
          this.changeStageTasks(UPDATE_STAGE_TASK.NEXT, task)
        }
      }
    },
    changeStageTasks (type, task = null) {
      let selectedTasksMutate = []
      let tasksForMutate = []
      if (type === UPDATE_STAGE_TASK.NEXT) {
        tasksForMutate = [task]
      } else {
        tasksForMutate = this.selectedTasks
      }
      selectedTasksMutate.push(tasksForMutate.forEach(task => {
        let stage = null
        if (type === UPDATE_STAGE_TASK.WAITING) {
          stage = this.stageQueue
        } else if (type === UPDATE_STAGE_TASK.FINISH) {
          stage = task.productOrder.deleted ? this.stageDeletedProduct : this.stageFinished
        } else if (type === UPDATE_STAGE_TASK.NEXT) {
          stage = this.stageWorking
        }
        this.spinningTasksIds.push(task.id)

        this.$apollo.mutate({
          mutation: WORKSHOP_CHANGE_STAGE,
          variables: {
            id: task.id,
            taskWorkshopPatch: {stageWorkshop: stage}
          }
        }).then((data) => {
          let taskId = data.data.updateTaskWorkshopById.taskWorkshop.id
          this.spinningTasksIds.splice(this.spinningTasksIds.indexOf(taskId), 1)
          let taskIndex = this.currentTasks.findIndex(task => task.id === taskId)
          if (type === UPDATE_STAGE_TASK.FINISH) {
            let overAllTaskIndex = this.tasksProducts.findIndex(el => el.id === taskId)
            if (overAllTaskIndex !== -1) {
              this.tasksProducts.splice(overAllTaskIndex, 1)
            }
            if (taskIndex !== -1) {
              this.currentTasks.splice(taskIndex, 1)
            }
          } else if (type === UPDATE_STAGE_TASK.WAITING) {
            if (taskIndex !== -1) {
              this.currentTasks.splice(taskIndex, 1)
            }
          } else if (type === UPDATE_STAGE_TASK.NEXT) {
            this.currentTasks.push(this.tasksProducts.find(task => task.id === taskId))
          }
        }).catch((error) => {
          this.$notify({
            group: 'default',
            title: 'Произошла ошибка',
            type: 'error',
            text: 'Ошибка смены статуса задачи'
          })
          console.error(error)
          this.spinningTasksIds = []
        })
      }))
      Promise.all(selectedTasksMutate).then(() => {
        if (type !== UPDATE_STAGE_TASK.NEXT) {
          this.selectedTasks = []
        }
      })
    },
    isSpinning (task) {
      return this.spinningTasksIds.some((id) => id === task.id)
    },
    readyTask () {
      this.changeStageTasks(UPDATE_STAGE_TASK.FINISH)
    },
    nextPage () {
      this.pageNumber++
    },
    prevPage () {
      this.pageNumber--
    },
    Cancel () {
      this.changeStageTasks(UPDATE_STAGE_TASK.WAITING)
    },
    waitingTime (time) {
      let timeInWait = this.$moment(time).fromNow()
      // timeInWait = order.timeCreation
      return timeInWait
    }
  },
  components: {
    TaskProductItem
  },
  computed: {
    pageCount () {
      let l = this.tasks.length
      let s = this.size
      return Math.max(Math.ceil(l / s), 1)
    },
    paginatedData () {
      const start = this.pageNumber * this.size
      const end = start + this.size
      return this.tasks
        .slice(start, end)
    },
    tasks () {
      return this.tasksProducts.filter((task) => {
        return task.stageWorkshop !== this.stageFinished
      })
    },
    isSelectedTasks () {
      return this.selectedTasks.length !== 0
    }
  }
}

</script>

<style lang="scss" scoped>
    .products {
        padding-left: 15px;
        padding-right: 15px;
    }
    .nullPad {
        padding-left: 0;
        padding-right: 0;
    }
    .pageInfo{
        height: 50px;
    }
    .pageInfo p{
        text-align: center;
        line-height: 10px;
        /*vertical-align: center;*/
    }
    .grid {
        display: grid;
    }

    .grid-3 {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: 33.33% 33.33% 33.33%;

        /*> .card:nth-child(3n + 1) {*/
            /*border-left: 1px solid rgba(0, 0, 0, 0.125);;*/
        /*}*/
    }
    .card-header {
        grid-column-start: 1;
        grid-column-end: 4;
    }
    .footPad {
        margin-bottom: 20px;
    }
    .stubCenter {
        display: flex;
        flex-grow:1;
        justify-content: center;
        align-content: space-between;
        align-items: center;
        flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// src/components/ListProducts.vue